import { render } from "./InstructionView.vue?vue&type=template&id=10774cc5&scoped=true&ts=true"
import script from "./InstructionView.vue?vue&type=script&lang=ts"
export * from "./InstructionView.vue?vue&type=script&lang=ts"

import "./InstructionView.vue?vue&type=style&index=0&id=10774cc5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10774cc5"]])

export default __exports__